import React, { Component, useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import swal from 'sweetalert';

import { GET_VIDEO_DETAIL } from 'utils';
import axios from 'axios';
import { EDIT_VIDEO, GET_TOKEN } from 'utils';

export default function EditVideo() {
  const { id } = useParams();
  const idKu = id.split(',');
  const history = useHistory();

  const [gambar, setGambar] = useState('');

  const [judul, setJudul] = useState('');
  const [sumber, setSumber] = useState('');
  const [tanggal, setTanggal] = useState('');
  const [link, setLink] = useState('');
  const [gantiGambar, setGantiGambar] = useState('tidak');
  const [saveLoading, setSaveLoading] = useState(false);

  const [urlFile1, setUrlFile1] = useState('');

  // auth

  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token', {
        credentials: 'include',
      });
      setAccessToken(response.data.accessToken);
    } catch (error) {
      if (error.response) {
        history.push('/admin/video');
      }
    }
  };
  //auth

  useEffect(() => {
    refreshToken();
    getDetailVideo();
  }, [id]);

  const getDetailVideo = async () => {
    var data1 = [];

    try {
      const response = await axios.get(GET_VIDEO_DETAIL + `${idKu[0]}`);
      data1 = response.data.data[0];
      console.log('data1 lanjut  ', data1);
      console.log(GET_VIDEO_DETAIL + id);

      if (data1) {
        setUrlFile1(data1.gambar.split(',')[0]);

        setJudul(data1.judul);
        setSumber(data1.sumber);
        setTanggal(data1.tanggal);
        setLink(data1.link);
      } else {
      }
      // berita.gambarKu = berita.gambar.split(',');
      // berita.isiKu = berita.isi.split('##');
    } catch (error) {
      console.error(error);
    }
  };

  function onChange1(e) {
    let uploaded = e.target.files[0];
    setUrlFile1(URL.createObjectURL(uploaded));
    setGambar(e.target.files[0]);
    setGantiGambar('ya');
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveLoading(true);

    if (judul && sumber && tanggal && link) {
      //action
      // this.props.dispatch(updateJersey(this.state));

      const formData = new FormData();
      formData.append('photo', gambar);
      formData.append('judul', judul);
      formData.append('sumber', sumber);
      formData.append('tanggal', tanggal);
      formData.append('link', link);
      formData.append('gantiGambar', gantiGambar);
      formData.append('idAdmin', idKu[1]);

      const response = await axios.patch(EDIT_VIDEO + `${idKu[0]}`, formData, {
        credentials: 'include',
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.data.success === 1) {
        swal('Success', 'Video berhasil diedit', 'success');
        history.push('/admin/video');
      }
    } else {
      swal('Failed', 'Maaf semua form wajib diisi', 'error');
    }
    setSaveLoading(false);
  };

  return (
    <div className='content'>
      <Row>
        <Col>
          <Link to='/admin/video' className='btn btn-primary'>
            Kembali
          </Link>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <CardHeader tag='h4'>Edit Video</CardHeader>
            <CardBody>
              <form onSubmit={(event) => handleSubmit(event)}>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col>
                        <img
                          src={urlFile1}
                          width='300'
                          alt='Foto Berita (satu)'
                        />
                        <FormGroup>
                          <label>Thumbnail Video</label>
                          <Input
                            type='file'
                            name='image1'
                            accept={'image/*'}
                            onChange={(event) => onChange1(event, 'imageToDB1')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label>Judul Video</label>
                      <Input
                        type='text'
                        value={judul}
                        name='nama'
                        onChange={(event) => setJudul(event.target.value)}
                      />
                    </FormGroup>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Sumber</label>
                          <Input
                            type='select'
                            name='liga'
                            value={sumber}
                            onChange={(event) => setSumber(event.target.value)}
                          >
                            <option value=''>--Pilih--</option>
                            <option value='Youtube DKISP'>Youtube DKISP</option>
                            <option value='Youtube Pemda'>Youtube Pemda</option>
                            <option value='Youtube Disbudpar'>
                              Youtube Disbudpar
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>Tanggal</label>
                          <Input
                            type='date'
                            value={tanggal}
                            name='harga'
                            onChange={(event) => setTanggal(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Link Video</label>
                          <Input
                            type='text'
                            value={link}
                            name='berat'
                            onChange={(event) => setLink(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col md={6}></Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>Ready</label>
                          <Input type='select' name='ready' value=''>
                            <option value={true}>Ada</option>
                            <option value={false}>Kosong</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row> */}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {saveLoading ? (
                      <Button color='primary' type='submit' disabled>
                        <Spinner size='sm' color='light' /> Loading
                      </Button>
                    ) : (
                      <Button type='submit' color='danger' className='ml-2'>
                        <i className='nc-icon nc-basket'></i> Simpan
                      </Button>
                    )}
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
